import React, { useMemo } from 'react';

interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string | { src: string; alt?: string }; // 支持字符串和对象类型的 src
}

export const LocalImage: React.FC<ImageProps> = ({ src, alt, ...props }) => {
  const srcUrl = useMemo(() => (typeof src === 'object' && src !== null ? src.src : src), [src]);

  return <img src={srcUrl} {...props} />;
};
